var CustomSelect = {

	init : function(){
		// CUSTOM SELECT
		var _select_container, i, j, selElmnt, select_selected, select_items, _item;
		/*look for any elements with the class "custom-select":*/
		_select_container = document.getElementsByClassName("custom-select");
		for (i = 0; i < _select_container.length; i++) {
			selElmnt = _select_container[i].getElementsByTagName("select")[0];
			/*for each element, create a new DIV that will act as the selected item:*/
			_container = document.createElement("DIV");
			_container.setAttribute("class", "select-container");

			_select_container[i].appendChild(_container);

			select_selected = document.createElement("DIV");
			select_selected.setAttribute("class", "select-selected");
			select_selected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
			_container.appendChild(select_selected);
			/*for each element, create a new DIV that will contain the option list:*/
			select_items = document.createElement("DIV");
			select_items.setAttribute("class", "select-items select-hide");

			for (j = 0; j < selElmnt.length; j++) {
				/*for each option in the original select element, create a new DIV that will act as an option item:*/
				_item = document.createElement("DIV");
				_item.innerHTML = selElmnt.options[j].innerHTML;

				//console.log("CREATE SELECT " + selElmnt.options[j].value);

				/*_item.setAttribute("class", selElmnt.options[j].value);*/
				
				if(selElmnt.options[j].value ){					
					_item.classList.add(selElmnt.options[j].value);
					if(selElmnt.options[j].hasAttribute('disabled')){
						_item.classList.add("disabled");
					}
				}else{
					_item.classList.add("no-value");
					if(selElmnt.options[j].hasAttribute('disabled')){
						_item.classList.add("disabled");
					}
				}
				if(_item.innerHTML == select_selected.innerHTML){
					/*_item.setAttribute("class", "same-as-selected");*/
					_item.classList.add("same-as-selected");
				}

				_item.addEventListener("click", function(e) {
					CustomSelect.clickOnItem(this);
				});
				select_items.appendChild(_item);
			}
			_container.appendChild(select_items);


			select_selected.addEventListener("click", function(e) {
				/*when the select box is clicked, close any other select boxes, and open/close the current select box:*/
				e.stopPropagation();
				CustomSelect.closeAllSelect(this);

				if(this.parentNode.parentNode.classList.contains('placeholder')){
					this.nextSibling.firstChild.style.display = "none";
				}
				this.nextSibling.classList.toggle("select-hide");
				this.classList.toggle("select-arrow-active");

				this.parentNode.parentNode.classList.toggle("open");
			});
		}

		/*if the user clicks anywhere outside the select box, then close all select boxes:*/
		document.addEventListener("click", CustomSelect.closeAllSelect);


	}, 
	clickOnItem:function(pTarget){
		/*when an item is clicked, update the original select box, and the selected item:*/
		var y, i, k, s, h;
		if(pTarget.classList.contains('disabled')){
			return;
		}
		s = pTarget.parentNode.parentNode.parentNode.getElementsByTagName("select")[0];
		h = pTarget.parentNode.previousSibling;	
		
		/*
		if(pTarget.parentNode.parentNode.parentNode.classList.contains('selected-in-grey')){
			pTarget.parentNode.parentNode.parentNode.classList.add("grey");
		}

		if(pTarget.parentNode.parentNode.parentNode.classList.contains('placeholder-in-white')){
			if(pTarget.classList == "placeholder"){
				pTarget.parentNode.parentNode.parentNode.classList.remove("grey");
			} 
		}

		if(pTarget.parentNode.parentNode.parentNode.classList.contains('selected-in-color-grey')){
			pTarget.parentNode.parentNode.parentNode.classList.add("color-grey");
		}
		*/
		for (i = 0; i < s.length; i++) {			
			if (s.options[i].innerHTML == pTarget.innerHTML) {
				
				s.selectedIndex = i;
				s.options[i].selected = true;
				h.innerHTML = pTarget.innerHTML;
				h.style.opacity = 1;

				y = pTarget.parentNode.getElementsByClassName("same-as-selected");

				for (k = 0; k < y.length; k++) {
					/*y[k].removeAttribute("class");*/
					y[k].classList.remove("same-as-selected");
				}

				/*this.setAttribute("class", "same-as-selected");*/
				pTarget.classList.add("same-as-selected");
				s.dispatchEvent(new Event('change'));
				break;
			}
		}
		h.click();
	},

	closeAllSelect: function(elmnt) {
		/*a function that will close all select boxes in the document,
  	except the current select box:*/


		var _select_container,  x, y, i, arrNo = [];

		_select_container = document.getElementsByClassName("custom-select");

		x = document.getElementsByClassName("select-items");
		y = document.getElementsByClassName("select-selected");		



		for (i = 0; i < y.length; i++) {

			if (elmnt == y[i]) {
				arrNo.push(i);
			} else {
				y[i].parentNode.parentNode.classList.remove("open");
				y[i].classList.remove("select-arrow-active");
			}
		}

		for (i = 0; i < _select_container.length; i++) {
			if (arrNo.indexOf(i)) {
				x[i].classList.add("select-hide");
			}
		}
	}
}


$(window).on("load", function(){
	console.log("WINDOW LOADED");
	if($(".akrolab-template .custom-select").length){
		CustomSelect.init();
	}
})